import React from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { isMobileDevice, getqbankDomain } from '../helpers/Utils';
import { logout, isInstituteGoalsDisabled } from '../actions';
import testInsights from '../shared/images/testInsights.svg';
import instituteInsights from '../shared/images/instituteInsights.svg';
import studentInsights from '../shared/images/student-insights.svg';

const cookies = new Cookies();
const IS_MOBILE = isMobileDevice();

class InsightsLandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInstituteGoalsDisabled: true,
      isStudentInsightsDisabled: true,
    };
  }

  componentDidMount() {
    this.props.isInstituteGoalsDisabled().then((response) => {
      if (response) {
        this.setState({
          isInstituteGoalsDisabled: response.is_disabled,
          isStudentInsightsDisabled: response.is_student_insights_disabled,
        });
      }
    });
  }

  renderCard(img, text, info, type, isDisabled) {
    if (isDisabled) return null;

    return (
      <a
        href={`/${type}`}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fff',
          borderRadius: 16,
          padding: IS_MOBILE ? '24px 16px' : '40px 32px',
          width: IS_MOBILE ? '100%' : 280,
          textDecoration: 'none',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          border: '1px solid #F0F0F5',
          transition: 'all 0.2s ease',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(108,92,231,0.12)';
          e.currentTarget.style.borderColor = '#6C5CE7';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
          e.currentTarget.style.borderColor = '#F0F0F5';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <div style={{
          width: IS_MOBILE ? 56 : 72,
          height: IS_MOBILE ? 56 : 72,
          borderRadius: 16,
          backgroundColor: '#F8F7FF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 20,
        }}>
          <img src={img} alt={text} style={{ height: IS_MOBILE ? 32 : 40 }} />
        </div>
        <div style={{
          fontSize: IS_MOBILE ? 16 : 18,
          fontWeight: '700',
          color: '#1a1a2e',
          marginBottom: 8,
          textAlign: 'center',
        }}>
          {text}
        </div>
        <div style={{
          fontSize: IS_MOBILE ? 12 : 13,
          color: '#9CA3AF',
          textAlign: 'center',
          lineHeight: 1.5,
        }}>
          {info}
        </div>
        <div style={{
          marginTop: 20,
          fontSize: 13,
          fontWeight: '600',
          color: '#6C5CE7',
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}>
          Open Dashboard
          <span style={{ fontSize: 16 }}>&rarr;</span>
        </div>
      </a>
    );
  }

  render() {
    const user = cookies.get('user');
    const { isInstituteGoalsDisabled, isStudentInsightsDisabled } = this.state;
    const { logout } = this.props;

    const pagesData = [
      {
        img: instituteInsights,
        url: 'progress',
        text: 'Institute Insights',
        info: 'Track institute performance, goals, and academic progress',
        isDisabled: isInstituteGoalsDisabled,
      },
      {
        img: testInsights,
        url: 'test_list',
        text: 'Test Insights',
        info: 'View test results, analytics, and student performance',
        isDisabled: false,
      },
      {
        img: studentInsights,
        url: 'student_insights/overview',
        text: 'Student Insights',
        info: 'Individual student performance tracking and analysis',
        isDisabled: isStudentInsightsDisabled,
      },
    ];

    return (
      <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#F8F9FC' }}>
        {/* Sidebar */}
        <div style={{
          width: IS_MOBILE ? 60 : 80,
          backgroundColor: '#1a1a2e',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '24px 0',
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          zIndex: 10,
        }}>
          <div
            role="presentation"
            style={{ cursor: 'pointer', textAlign: 'center' }}
            onClick={() => { window.location.href = `${getqbankDomain()}`; }}
          >
            <span style={{ color: '#FF4757', fontWeight: 'bold', fontSize: IS_MOBILE ? 18 : 24 }}>I</span>
            <span style={{ color: '#fff', fontWeight: '600', fontSize: IS_MOBILE ? 18 : 24 }}>B</span>
            <div style={{ fontSize: IS_MOBILE ? 9 : 11, fontWeight: '500', color: '#6B7280', marginTop: 4, letterSpacing: '0.5px' }}>
              INSIGHTS
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: IS_MOBILE ? 32 : 40,
              height: IS_MOBILE ? 32 : 40,
              borderRadius: '50%',
              background: '#6C5CE7',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              fontSize: IS_MOBILE ? 14 : 16,
              fontWeight: '600',
            }}>
              {user ? user.name.charAt(0).toUpperCase() : ''}
            </div>
            <div
              onClick={() => logout()}
              role="presentation"
              style={{
                color: '#6B7280',
                fontSize: IS_MOBILE ? 10 : 12,
                cursor: 'pointer',
                fontWeight: '500',
              }}
            >
              Log out
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div style={{
          flex: 1,
          marginLeft: IS_MOBILE ? 60 : 80,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: IS_MOBILE ? 20 : 40,
        }}>
          <div style={{
            fontSize: IS_MOBILE ? 24 : 32,
            fontWeight: '800',
            color: '#1a1a2e',
            marginBottom: 8,
          }}>
            Insights Board
          </div>
          <div style={{
            fontSize: IS_MOBILE ? 14 : 16,
            color: '#9CA3AF',
            marginBottom: IS_MOBILE ? 32 : 48,
          }}>
            Choose a dashboard to get started
          </div>

          <div style={{
            display: 'flex',
            flexDirection: IS_MOBILE ? 'column' : 'row',
            gap: IS_MOBILE ? 16 : 24,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}>
            {pagesData.map((page) => (
              <div key={page.url}>
                {this.renderCard(page.img, page.text, page.info, page.url, page.isDisabled)}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

InsightsLandingPage.defaultProps = {
  isInstituteGoalsDisabled: true,
};

export default connect(null, { isInstituteGoalsDisabled, logout })(InsightsLandingPage);
